import Router from "vue-router";

// 懒加载方式，当路由被访问的时候才加载对应组件
const Home = resolve => require(["@/components/Home"], resolve);
const User = resolve => require(["@/components/user/User"], resolve);
const Login = resolve => require(["@/components/user/Login"], resolve);

const temp = resolve => require(["@/components/temp"], resolve);
const center = resolve => require(["@/components/common/center"], resolve);
const main = resolve => require(["@/components/common/main"], resolve);
const rooms = resolve => require(["@/components/member/rooms"], resolve);
const coachs = resolve => require(["@/components/member/coachs"], resolve);
const basicInfo = resolve => require(["@/components/member/basicInfo"], resolve);
const target = resolve => require(["@/components/member/target"], resolve);
const record = resolve => require(["@/components/member/record"], resolve);
const userCourse = resolve => require(["@/components/member/userCourse"], resolve);
const myCoach = resolve => require(["@/components/member/myCoach"], resolve);
const myAppointment = resolve => require(["@/components/member/myAppointment"], resolve);
const myStatus = resolve => require(["@/components/member/myStatus"], resolve);
const myCourse = resolve => require(["@/components/member/myCourse"], resolve);
const userstatusTable = resolve => require(["@/components/member/userstatusTable"], resolve);
const order = resolve => require(["@/components/member/order"], resolve);
const appointment = resolve => require(["@/components/member/appointment"], resolve);
const orderDetail = resolve => require(["@/components/member/orderDetail"], resolve);
const coachDetail = resolve => require(["@/components/member/coachDetail"], resolve);
const roomDetail = resolve => require(["@/components/member/roomDetail"], resolve);
const changeCoach = resolve => require(["@/components/member/changeCoach"], resolve);
const coachInfo = resolve => require(["@/components/coach/coachInfo"], resolve);
const memberMange = resolve => require(["@/components/coach/memberMange"], resolve);
const myMember = resolve => require(["@/components/coach/myMember"], resolve);
const appointmentMember = resolve => require(["@/components/coach/appointmentMember"], resolve);
const myTable = resolve => require(["@/components/coach/myTable"], resolve);
const myIncome = resolve => require(["@/components/coach/myIncome"], resolve);
const coachSetting = resolve => require(["@/components/coach/coachSetting"], resolve);
const orderManage = resolve => require(["@/components/coach/orderManage"], resolve);
const coachOrderDetail = resolve => require(["@/components/coach/coachOrderDetail"], resolve);
const appointmentCoach = resolve => require(["@/components/coach/appointmentCoach"], resolve);
const refund = resolve => require(["@/components/manager/refund"], resolve);
const roomCoach = resolve => require(["@/components/manager/roomCoach"], resolve);
const roomOrder = resolve => require(["@/components/manager/roomOrder"], resolve);
const sell = resolve => require(["@/components/manager/sell"], resolve);
const sellDetail = resolve => require(["@/components/manager/sellDetail"], resolve);
const coachTable = resolve => require(["@/components/manager/coachTable"], resolve);
const roomMemberMange = resolve => require(["@/components/manager/roomMemberMange"], resolve);
const memberDetail = resolve => require(["@/components/manager/memberDetail"], resolve);
const memberEdit = resolve => require(["@/components/manager/memberEdit"], resolve);
const editCoach = resolve => require(["@/components/manager/editCoach"], resolve);
const addCoach = resolve => require(["@/components/manager/addCoach"], resolve);
const addCourse = resolve => require(["@/components/manager/addCourse"], resolve);
const addMember = resolve => require(["@/components/manager/addMember"], resolve);
const addStatus = resolve => require(["@/components/manager/addStatus"], resolve);
const classSetting = resolve => require(["@/components/manager/classSetting"], resolve);
const manager = resolve => require(["@/components/topManager/manager"], resolve);
const roomManage = resolve => require(["@/components/topManager/roomManage"], resolve);
const userTable = resolve => require(["@/components/topManager/userTable"], resolve);
const roomTable = resolve => require(["@/components/topManager/roomTable"], resolve);
const roomManageDetail = resolve => require(["@/components/topManager/roomManageDetail"], resolve);
const userMange = resolve => require(["@/components/topManager/userMange"], resolve);
const roomSetting = resolve => require(["@/components/manager/roomSetting"], resolve);
const first = resolve => require(["@/components/common/first"], resolve);
const second = resolve => require(["@/components/common/second"], resolve);
const userDashboard = resolve => require(["@/components/dashboard/userDashboard"], resolve);
const roomDashboard = resolve => require(["@/components/dashboard/roomDashboard"], resolve);
const appointmentCalendar = resolve => require(["@/components/dashboard/appointmentCalendar"], resolve);

const orderToday = resolve => require(["@/components/member/orderToday"], resolve);

//废弃
const userMainPage = resolve => require(["@/components/member/userMainPage"], resolve);
const userInfo = resolve => require(["@/components/member/userInfo"], resolve);
const coachCenter = resolve => require(["@/components/coach/coachCenter"], resolve);
const coachMainPage = resolve => require(["@/components/coach/coachMainPage"], resolve);
const roomCourse = resolve => require(["@/components/manager/roomCourse"], resolve);
const publishCourse = resolve => require(["@/components/coach/publishCourse"], resolve);
const sumCourse = resolve => require(["@/components/coach/sumCourse"], resolve);
const orderRecord = resolve => require(["@/components/member/orderRecord"], resolve);
const table = resolve => require(["@/components/table/table"], resolve);

let router = new Router({
  routes: [{
      path: "/first",
      component: first,
      name: "first",
      menuShow: true
    }, {
      path: "/second",
      component: second,
      name: "second",
      menuShow: true
    }, {
      path: "/login",
      component: Login,
      name: "login",
      menuShow: true
    },
    {
      path: "/",
      component: Home,
      redirect: "/first",
      children: [{
          path: "/temp",
          component: temp,
          name: "temp",
          menuShow: true
        },
        {
          path: "/user",
          component: User,
          name: "user",
          menuShow: true
        },
        {
          path: "/coachCenter",
          component: coachCenter,
          name: "coachCenter",
          menuShow: true
        },
        {
          path: "/table",
          component: table,
          name: "table",
          menuShow: true
        },
        {
          path: "/rooms",
          component: rooms,
          name: "rooms",
          menuShow: true
        },
        {
          path: "/coachs",
          component: coachs,
          name: "coachs",
          menuShow: true
        },
        {
          path: "/userMainPage",
          component: userMainPage,
          name: "userMainPage",
          menuShow: true
        },
        {
          path: "/userInfo",
          component: userInfo,
          name: "userInfo",
          menuShow: true
        },
        {
          path: "/basicInfo",
          component: basicInfo,
          name: "basicInfo",
          menuShow: true
        }, {
          path: "/target",
          component: target,
          name: "target",
          menuShow: true
        }, {
          path: "/record",
          component: record,
          name: "record",
          menuShow: true
        },
        {
          path: "/userCourse",
          component: userCourse,
          name: "userCourse",
          menuShow: true
        },
        {
          path: "/myCoach",
          component: myCoach,
          name: "myCoach",
          menuShow: true
        },
        {
          path: "/appointment",
          component: appointment,
          name: "appointment",
          menuShow: true
        },
        {
          path: "/order",
          component: order,
          name: "order",
          menuShow: true
        },
        {
          path: "/orderDetail",
          component: orderDetail,
          name: "orderDetail",
          menuShow: true
        }, {
          path: "/orderRecord",
          component: orderRecord,
          name: "orderRecord",
          menuShow: true
        }, {
          path: "/coachInfo",
          component: coachInfo,
          name: "coachInfo",
          menuShow: true
        }, {
          path: "/coachMainPage",
          component: coachMainPage,
          name: "coachMainPage",
          menuShow: true
        }, {
          path: "/memberMange",
          component: memberMange,
          name: "memberMange",
          menuShow: true
        }, {
          path: "/orderManage",
          component: orderManage,
          name: "orderManage",
          menuShow: true
        }, {
          path: "/publishCourse",
          component: publishCourse,
          name: "publishCourse",
          menuShow: true
        }, {
          path: "/sumCourse",
          component: sumCourse,
          name: "sumCourse",
          menuShow: true
        }, {
          path: "/refund",
          component: refund,
          name: "refund",
          menuShow: true
        }, {
          path: "/roomCoach",
          component: roomCoach,
          name: "roomCoach",
          menuShow: true
        }, {
          path: "/roomCourse",
          component: roomCourse,
          name: "roomCourse",
          menuShow: true
        }, {
          path: "/roomOrder",
          component: roomOrder,
          name: "roomOrder",
          menuShow: true
        }, {
          path: "/roomSetting",
          component: roomSetting,
          name: "roomSetting",
          menuShow: true
        }, {
          path: "/manager",
          component: manager,
          name: "manager",
          menuShow: true
        }, {
          path: "/roomManage",
          component: roomManage,
          name: "roomManage",
          menuShow: true
        }, {
          path: "/center",
          component: center,
          name: "center",
          menuShow: true
        }, {
          path: "/main",
          component: main,
          name: "main",
          menuShow: true
        }, {
          path: "/userstatusTable",
          component: userstatusTable,
          name: "userstatusTable",
          menuShow: true
        }, {
          path: "/coachTable",
          component: coachTable,
          name: "coachTable",
          menuShow: true
        }, {
          path: "/userTable",
          component: userTable,
          name: "userTable",
          menuShow: true
        }, {
          path: "/roomTable",
          component: roomTable,
          name: "roomTable",
          menuShow: true
        }, {
          path: "/coachDetail",
          component: coachDetail,
          name: "coachDetail",
          menuShow: true
        }, {
          path: "/roomDetail",
          component: roomDetail,
          name: "roomDetail",
          menuShow: true
        }, {
          path: "/myAppointment",
          component: myAppointment,
          name: "myAppointment",
          menuShow: true
        }, {
          path: "/myStatus",
          component: myStatus,
          name: "myStatus",
          menuShow: true
        }, {
          path: "/myCourse",
          component: myCourse,
          name: "myCourse",
          menuShow: true
        }, {
          path: "/myMember",
          component: myMember,
          name: "myMember",
          menuShow: true
        }, {
          path: "/appointmentMember",
          component: appointmentMember,
          name: "appointmentMember",
          menuShow: true
        }, {
          path: "/myTable",
          component: myTable,
          name: "myTable",
          menuShow: true
        }, {
          path: "/myIncome",
          component: myIncome,
          name: "myIncome",
          menuShow: true
        }, {
          path: "/coachSetting",
          component: coachSetting,
          name: "coachSetting",
          menuShow: true
        }, {
          path: "/coachOrderDetail",
          component: coachOrderDetail,
          name: "coachOrderDetail",
          menuShow: true
        }, {
          path: "/roomManageDetail",
          component: roomManageDetail,
          name: "roomManageDetail",
          menuShow: true
        }, {
          path: "/roomMemberMange",
          component: roomMemberMange,
          name: "roomMemberMange",
          menuShow: true
        }, {
          path: "/memberDetail",
          component: memberDetail,
          name: "memberDetail",
          menuShow: true
        }, {
          path: "/memberEdit",
          component: memberEdit,
          name: "memberEdit",
          menuShow: true
        }, {
          path: "/editCoach",
          component: editCoach,
          name: "editCoach",
          menuShow: true
        }, {
          path: "/userMange",
          component: userMange,
          name: "userMange",
          menuShow: true
        }, {
          path: "/changeCoach",
          component: changeCoach,
          name: "changeCoach",
          menuShow: true
        }, {
          path: "/appointmentCoach",
          component: appointmentCoach,
          name: "appointmentCoach",
          menuShow: true
        }, {
          path: "/addStatus",
          component: addStatus,
          name: "addStatus",
          menuShow: true
        }, {
          path: "/addCoach",
          component: addCoach,
          name: "addCoach",
          menuShow: true
        }, {
          path: "/addCourse",
          component: addCourse,
          name: "addCourse",
          menuShow: true
        }, {
          path: "/addMember",
          component: addMember,
          name: "addMember",
          menuShow: true
        }, {
          path: "/classSetting",
          component: classSetting,
          name: "classSetting",
          menuShow: true
        },{
          path: "/userDashboard",
          component: userDashboard,
          name: "userDashboard",
          menuShow: true
        },{
          path: "/roomDashboard",
          component: roomDashboard,
          name: "roomDashboard",
          menuShow: true
        },{
          path: "/appointmentCalendar",
          component: appointmentCalendar,
          name: "appointmentCalendar",
          menuShow: true
        },{
          path: "/sell",
          component: sell,
          name: "sell",
          menuShow: true
        },{
          path: "/sellDetail",
          component: sellDetail,
          name: "sellDetail",
          menuShow: true
        },{
          path: "/orderToday",
          component: orderToday,
          name: "orderToday",
          menuShow: true
        },
      ]
    }
  ]
});

// router.beforeEach((to, from, next) => {
//   // console.log('to:' + to.path)
//   if (to.path.startsWith('/login')) {
//     window.localStorage.removeItem('access-user')
//     next()
//   } else {
//     let user = JSON.parse(window.localStorage.getItem('access-user'))
//     if (!user) {
//       next({path: '/login'})
//     } else {
//       next()
//     }
//   }
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js